import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewChildren, QueryList, Inject, Input, forwardRef } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AppComponent, RootEnum } from 'app/app.component';
import { AppDataService, GeoZoneService, OperatorService } from 'app/services';
import {
    XpressUserRoleEnum,
    MerchantStatusEnum,
    ServiceTypeEnum,
    RootMenuEnum, MenuPermissionActionEnum, MenuPermissionConfig, BackOfficeEnum, BetaFeature,
    XpressClientLocationTypeModel, XpressClientLocationTypeEnum
} from 'app/models';
import { MenuHomeEnum } from 'app/home';
import { MenuitemComponent } from '../menuitem/menuitem.component';
import { MenuLinkEnum } from 'app/layout/menuitem/menu-link.enum';
import { MenuLabel } from 'app/layout/menuitem/menu-label';
import { MenuIcons, PartnerMenuIcons, TourOperatorMenuIcons } from 'app/layout/menuitem/menu-icons';
import { navigationMenuTestId } from 'app/layout/menuitem/navigation-menu-testid';
import { OpsTowerMenuEnum } from 'app/ops-tower';
import { MarketingMenuEnum } from 'app/marketing';
import { CommsMenuEnum } from 'app/comms';
import { SideMenuReportEnum } from 'app/report';
import { SettingsMenuEnum } from 'app/settings';
import { FinanceMenuEnum } from 'app/finance';
import { OperatorHomeMenuEnum } from 'app/operator';
import { CustomWindow } from 'app/@types';
import { ProvideTestId, TEST_ID_TOKEN } from 'app/providers';
import { Router } from '@angular/router';

declare let window: CustomWindow;

@Component({
    selector: 'menu',
    templateUrl: './menu.component.html',
    providers:[ProvideTestId('app-menu')],
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
    public model: MenuItem[] = [];
    public readonly navigationMenuTestId = navigationMenuTestId;
    public menuPermissionConfig = MenuPermissionConfig;
    public isNewBookingsReports = window['isNewBookingsReports'];

    private merchanUserSubscription: Subscription | undefined = undefined;
    private permissionsSubscription: Subscription | undefined = undefined;
    public isLGUAdmin: boolean = false;
	private showConnexService: boolean = true;

    constructor(public app: AppComponent,
        private messageService: MessageService,
        private geoZoneService: GeoZoneService,
        private router: Router,
		public appData: AppDataService,
        private operatorService: OperatorService,
        @Inject(TEST_ID_TOKEN) public componentTestId: string)
	{
		if (this.isMerchant() || this.isOperator()) {
			this.app.isStateBased = true;
		}
        this.isLGUAdmin = this.appData.hasPermission(MenuPermissionConfig.LGU_ADMIN, MenuPermissionActionEnum.Read);

        if(this.isLGUAdmin){
            this.selectClientLocationType = XpressClientLocationTypeEnum.Boracay;
        } else {
            const clientLocationTypeSessionStorage = sessionStorage.getItem('clientLocationType');
            this.selectClientLocationType = (clientLocationTypeSessionStorage && !isNaN(+clientLocationTypeSessionStorage))
                ? (+clientLocationTypeSessionStorage as XpressClientLocationTypeEnum)
                : XpressClientLocationTypeEnum.Xpress;
        }

    }

    public apiBuildNumber: string | null = '';
    public webBuildNumber: string = '';

    public geoZones: Array<any> = [];
    public permissions: Array<any> = [];
    public selectGeoZone: any;
    public set _selectGeoZone(value: any) {
        this.selectGeoZone = value;
        this.changedGeoZone(value);
    }
    public isVisibleAreaNotActiveModal: boolean = false;

    public _profile: any;

    @Input()
    set profile(value: any) {
            console.log('Input username changed:', value);
            // eslint-disable-next-line no-underscore-dangle
            this._profile = value; // example transformation
    }
    @Output() changedGeoZoneEmit = new EventEmitter<any>();

    public serviceTypeId!: ServiceTypeEnum;

    public rootMenuEnum = RootMenuEnum;
    public activeRootMenu: RootMenuEnum | null = null;

    public menuEnum = MenuHomeEnum;
    public activeMenu: MenuHomeEnum = MenuHomeEnum.Dashboard;

    public xpressClientLocationTypeList: any;
    public selectClientLocationType: XpressClientLocationTypeEnum;
    private clientLocationTypeChangeInitialized: boolean = false;

    @ViewChildren(forwardRef(() => MenuitemComponent))
    menuItems!: QueryList<MenuitemComponent>;

    isMerchant() {
        return +this.appData.authData.roleId === XpressUserRoleEnum.Merchant;
	}

	isOperator() {
		return +this.appData.authData.roleId === XpressUserRoleEnum.Operator;
	}

    addMenuItems(target: any, items: Array<any>) {
        for (const item of items) {
            if (this.appData.hasPermission(item.id, MenuPermissionActionEnum.Read)) {
                if (item.isRoot) {
                    this.model.push(item);
                } else {
                    target.items.push(item);
                }
            }
        }
    }

    addHomeBoracay() {
        const home = { root: RootEnum.Home, label: MenuLabel.Home, icon: MenuIcons.Home, items: new Array<any>(), id: MenuPermissionConfig.HOME, isRoot: true };
        const homeItems = [
            home,
            {
                root: RootEnum.Home, menuFlag: MenuHomeEnum.Dashboard, label: MenuLabel.HomeDashboard,
                id: MenuPermissionConfig.HOME_DASHBOARD,
                route: ['/xpressadmin/home/dashboard']
            },
        ];
        this.addMenuItems(home, homeItems);
    }

    addOpsTowerBoracay() {
        const opsTower = {
            root: RootEnum.OpsTower, label: MenuLabel.OpsTower,
            icon: MenuIcons.OpsTower, items: new Array<any>(), id: MenuPermissionConfig.OPS_TOWER, isRoot: true
        };
        const reportsOps = {
            label: MenuLabel.OpsReports,
            items: new Array<any>(), id: MenuPermissionConfig.OPS_TOWER_REPORTS
        };
        const opsTowerItems = [
			opsTower,
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.Dashboard, label: MenuLabel.OpsDashboard,
				id: MenuPermissionConfig.OPS_TOWER_DASHBOARD,
				route: ['/xpressadmin/ops-tower']
            },
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.LiveMap, label: MenuLabel.OpsLiveMap,
				id: MenuPermissionConfig.OPS_TOWER_LIVE_MAP,
				route: ['/xpressadmin/ops-tower/live-map']
            },
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.HeatMap, label: MenuLabel.OpsHeatMap,
				id: MenuPermissionConfig.OPS_TOWER_HEAT_MAP,
				route: ['/xpressadmin/ops-tower/heat-map']
            },
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ActiveOrder, label: MenuLabel.OpsBookings,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS
            },
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.Users, label: MenuLabel.OpsUsers,
                id: MenuPermissionConfig.OPS_TOWER_USERS
            },
            reportsOps
        ];

        this.addMenuItems(opsTower, opsTowerItems);

        const reportsItems = [
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ReportsDrivers, label: MenuLabel.OpsDrivers,
                id: MenuPermissionConfig.OPS_TOWER_REPORTS_DRIVERS, route: ['/xpressadmin/ops-tower/drivers']
            },
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ReportsCustomers, label: MenuLabel.OpsCustomers,
                id: MenuPermissionConfig.OPS_TOWER_REPORTS_CUSTOMERS, route: ['/xpressadmin/ops-tower/customers']
            }
        ];
        this.addMenuItems(reportsOps, reportsItems);
    }

    private checkShowZonesmap(): boolean {
        return this.appData.authData.BetaFeatures.includes(BetaFeature.ShowZonesmap);
    }

    private checkShowNewBookingsReports(): boolean {
        return this.isNewBookingsReports;
    }

    addApplicationBoracay() {
        //application(back-office)
        const application = {
            root: RootEnum.BackOffice, label: MenuLabel.Application,
            icon: MenuIcons.Application, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE, isRoot: true
        };
        this.addMenuItems(this.model, [application]);
        const operators = { label: MenuLabel.Operators, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_OPERATORS };
        this.addMenuItems(application, [operators]);

        const operatorsItems = [
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.OperatorsVehicles, label: MenuLabel.Vehicles,
                id: MenuPermissionConfig.BACK_OFFICE_OPERATORS_VEHICLES
            }
        ];

        if (!this.isLGUAdmin) {
            operatorsItems.push({
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.OperatorsTODAs, label: MenuLabel.TODAs,
                id: MenuPermissionConfig.BACK_OFFICE_OPERATORS_TODAS
            });
        }
        this.addMenuItems(operators, operatorsItems);

        const vehicles = {
            root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.OperatorsVehicles,
            label: MenuLabel.Vehicles, id: MenuPermissionConfig.BACK_OFFICE_VEHICLES
        };
        this.addMenuItems(application, [vehicles]);

        //drivers
        const drivers = { label: MenuLabel.Drivers, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS };
        this.addMenuItems(application, [drivers]);

        const driver = { label: MenuLabel.Driver, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DRIVER };

        if (this.appData.isDumagueteLocation) {
            const driversItems = [driver];
            this.addMenuItems(drivers, driversItems);
        } else {
            const disciplinary = { label: MenuLabel.Disciplinary, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY };
            const campaignRiders = { label: MenuLabel.CampaignRiders, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_CAMPAIGN_RIDERS };

            const driversItems = [driver, disciplinary, campaignRiders];
            this.addMenuItems(drivers, driversItems);

            //disciplinary
            const disciplinaryItems = [
                {
                    root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.DisciplinaryNewCases, label: MenuLabel.NewCases,
                    id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY_NEW_CASES
                },
                {
                    root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.DisciplinaryInProcess, label: MenuLabel.InProcess,
                    id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY_IN_PROCESS
                },
                {
                    root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.DisciplinaryArchived, label: MenuLabel.Archived,
                    id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY_ARCHIVED
                }
            ];
            this.addMenuItems(disciplinary, disciplinaryItems);

            //campaign riders
            const campaignRidersItems = [
                {
                    root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.CompaignDrivers, label: MenuLabel.Campaign3W,
                    id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_CAMPAIGN_RIDERS_CAMPAIGN_3W, backOffice: BackOfficeEnum.Passenger3W
                },
                {
                    root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.CompaignDrivers, label: MenuLabel.Campaign4W,
                    id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_CAMPAIGN_RIDERS_CAMPAIGN_4W, backOffice: BackOfficeEnum.Passenger4W
                }
            ];
            this.addMenuItems(campaignRiders, campaignRidersItems);
        }

        //driver
        const driverItems: any[] = [
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.Drivers, label: MenuLabel.Passenger3W,
                id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DRIVER_PASSENGER_3W, backOffice: BackOfficeEnum.Passenger3W
            }
        ];

        if (!this.isLGUAdmin && !this.appData.isDumagueteLocation) {
            driverItems.push({
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.Drivers, label: MenuLabel.Delivery2W,
                id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DRIVER_DELIVERY_2W, backOffice: BackOfficeEnum.Delivery2W
            });
            driverItems.push({
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.Drivers, label: MenuLabel.Passenger4W,
                id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DRIVER_PASSENGER_4W, backOffice: BackOfficeEnum.Passenger4W
            });
            driverItems.push({
                label: MenuLabel.LoopPassDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.LoopPassCampaign, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DRIVER_PASSENGER_3W,
                key: 'back-office-drivers-loop-pass',
                backOffice: BackOfficeEnum.Passenger3W
            });
        }
        this.addMenuItems(driver, driverItems);

        //user
        if(!this.isLGUAdmin){
            const user = {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.Users,
                label: MenuLabel.User, id: MenuPermissionConfig.BACK_OFFICE_USERS
            };
            this.addMenuItems(application, [user]);

            //operators
            const operators2 = {
                label: MenuLabel.Operators, items: new Array<any>(),
                id: MenuPermissionConfig.BACK_OFFICE_TRANSACTIONS, key: 'back-office-operators-transactions'
            };
            this.addMenuItems(application, [operators2]);
            const operators2Items = [
                {
                    root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.OperatorsVehicles, label: MenuLabel.Operators,
                    id: MenuPermissionConfig.BACK_OFFICE_OPERATORS_OPERATORS
                },
                {
                    root: RootEnum.BackOffice, label: MenuLabel.Owners,
                    id: MenuPermissionConfig.BACK_OFFICE_OPERATORS_OWNERS
                }
            ];
            this.addMenuItems(operators2, operators2Items);
        }

        //transactions
        const transactions = { label: MenuLabel.Transactions, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_TRANSACTIONS };
        this.addMenuItems(application, [transactions]);
        const transactionsItems = [
            {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.CustomerWallet, label: MenuLabel.Customer,
                id: MenuPermissionConfig.BACK_OFFICE_TRANSACTIONS_CUSTOMER,
                route: ['/xpressadmin/finance/application/customer']
            },
            {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.DriverWallet, label: MenuLabel.Drivers,
                id: MenuPermissionConfig.BACK_OFFICE_TRANSACTIONS_DRIVERS,
                route: ['/xpressadmin/finance/application/drivers']
            }
        ];
        this.addMenuItems(transactions, transactionsItems);
    }

    addFeedbackBoracay() {
        const feedback = { label: MenuLabel.Feedbacks, icon: MenuIcons.Application, isRoot: true };
        this.addMenuItems(this.model, [feedback]);
    }

    addHome() {
        const home = { root: RootEnum.Home, label: MenuLabel.Home, icon: MenuIcons.Home, items: new Array<any>(), id: MenuPermissionConfig.HOME, isRoot: true };
        const homeItems = [
            home,
            {
                root: RootEnum.Home, label: MenuLabel.HomeDashboard, menuFlag: MenuHomeEnum.Dashboard,
				id: MenuPermissionConfig.HOME_DASHBOARD,
				route: ['/xpressadmin/home/dashboard']
            },
            {
                root: RootEnum.Home, label: MenuLabel.HomeSystemStatus, menuFlag: MenuHomeEnum.SystemStatus,
				id: MenuPermissionConfig.HOME_SYSTEM_STATUS,
				route: ['/xpressadmin/home/system-status']

            }
        ];

        this.addMenuItems(home, homeItems);
    }

    addOpsTower() {
        const opsTower = {
            root: RootEnum.OpsTower, label: MenuLabel.OpsTower,
            icon: MenuIcons.OpsTower, items: new Array<any>(), id: MenuPermissionConfig.OPS_TOWER, isRoot: true
        };
        this.addMenuItems(this.model, [opsTower]);

        const bookingsOps = {
            label: MenuLabel.OpsBookings,
            items: new Array<any>(), id: MenuPermissionConfig.OPS_TOWER_BOOKINGS
        };
        const reportsOps = {
            label: MenuLabel.OpsReports,
            items: new Array<any>(), id: MenuPermissionConfig.OPS_TOWER_REPORTS
        };
        const opsTowerItems: any[] = [
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsDashboard, menuFlag: OpsTowerMenuEnum.Dashboard,
				id: MenuPermissionConfig.OPS_TOWER_DASHBOARD,
				route: ['/xpressadmin/ops-tower']
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsLiveMap, menuFlag: OpsTowerMenuEnum.LiveMap,
				id: MenuPermissionConfig.OPS_TOWER_LIVE_MAP,
				route: ['/xpressadmin/ops-tower/live-map']
            },
            {
				root: RootEnum.OpsTower, label: MenuLabel.OpsHeatMap,
				menuFlag: OpsTowerMenuEnum.HeatMap,
				id: MenuPermissionConfig.OPS_TOWER_HEAT_MAP,
				route: ['/xpressadmin/ops-tower/heat-map']
            },
            bookingsOps,
            reportsOps
        ];

        if (this.checkShowZonesmap() === true) {
            const liveMapIndex = opsTowerItems.findIndex((item: any) => item.menuFlag === OpsTowerMenuEnum.LiveMap);
            if (liveMapIndex !== -1) {
                opsTowerItems.splice(liveMapIndex + 1, 0,
                    {
                        root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ZonesMap, label: MenuLabel.OpsZonesMap,
						id: MenuPermissionConfig.OPS_TOWER_LIVE_MAP, key: 'ops-tower-zone-map',
                        route: ['/xpressadmin/ops-tower/zone-map']
                    });
            }
        }

        this.addMenuItems(opsTower, opsTowerItems);

        let bookingItems: any[] = [
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsRide, menuFlag: OpsTowerMenuEnum.BookingRide,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_RIDE
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsTaxiRides, menuFlag: OpsTowerMenuEnum.BookingTaxi,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_RIDE, key: 'ops-tower-bookings-taxi'
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsSend, menuFlag: OpsTowerMenuEnum.BookingSend,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_SEND
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.Xpass, menuFlag: OpsTowerMenuEnum.Xpass,
                id: MenuPermissionConfig.OPS_TOWER_XPASS
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.Tour, menuFlag: OpsTowerMenuEnum.Tour,
                id: MenuPermissionConfig.EXPERIENCE_BOOKING_OVERSIGHT
			},
			{
				root: RootEnum.OpsTower, label: MenuLabel.ExperienceListings, menuFlag: OpsTowerMenuEnum.ExperienceListings,
				id: MenuPermissionConfig.EXPERIENCE_LISTING_REVIEW
			},
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsDelivery, menuFlag: OpsTowerMenuEnum.BookingDelivery,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_DELIVERY
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsRent, menuFlag: OpsTowerMenuEnum.BookingRent,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_RENT
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsPetTaxi, menuFlag: OpsTowerMenuEnum.BookingPetTaxi,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_PET_TAXI
            },
            {
                root: RootEnum.OpsTower, label: MenuLabel.OpsTransfers, menuFlag: OpsTowerMenuEnum.BookingTransfers,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_TRANSFERS
            }
        ];

        if (this.checkShowNewBookingsReports()) {
            bookingItems = bookingItems.concat(
                {
                    root: RootEnum.OpsTower, label: MenuLabel.OpsMoto, menuFlag: OpsTowerMenuEnum.BookingMoto,
                    id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_MOTO
                },
                {
                    root: RootEnum.OpsTower, label: MenuLabel.OpsCars, menuFlag: OpsTowerMenuEnum.BookingCars,
                    id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_CARS
                },
                {
                    root: RootEnum.OpsTower, label: MenuLabel.OpsAdmin, menuFlag: OpsTowerMenuEnum.BookingAdmin,
                    id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_ADMIN
                });
        }

        const connexBookingsGroup = {
            label: MenuLabel.ConneX,
            items: new Array<any>(),
            id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_CONNEX
        };

        this.addMenuItems(bookingsOps, bookingItems);
        this.addMenuItems(bookingsOps, [connexBookingsGroup]);

        const connexBookingsItems: any[] = [
            {
                root: RootEnum.OpsTower,
                label: MenuLabel.ConnexBookings,
                menuFlag: OpsTowerMenuEnum.ConnexBookings,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_CONNEX_BOOKINGS
            }
        ];

		if (this.showConnexService !== false) {
			connexBookingsItems.push({
                root: RootEnum.OpsTower,
                label: MenuLabel.ConnexRouteConfiguration,
                menuFlag: OpsTowerMenuEnum.ConnexRouteConfiguration,
                id: MenuPermissionConfig.OPS_TOWER_BOOKINGS_CONNEX_ROUTE_CONFIGURATION
            });
		}
        this.addMenuItems(connexBookingsGroup, connexBookingsItems);

        const reportsItems: any[] = [
			{
				root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ReportsDrivers, label: MenuLabel.OpsDrivers,
				id: MenuPermissionConfig.OPS_TOWER_REPORTS_DRIVERS, route: ['/xpressadmin/ops-tower/drivers']
			},
			{
				root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ReportsCustomers, label: MenuLabel.OpsCustomers,
				id: MenuPermissionConfig.OPS_TOWER_REPORTS_CUSTOMERS, route: ['/xpressadmin/ops-tower/customers']
			},
			{
				root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ReportsOperators, label: MenuLabel.OpsOperators,
                id: MenuPermissionConfig.OPS_TOWER_REPORTS_OPERATORS
            },
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.ReportsDailyStatistics, label: MenuLabel.OpsDailyStatistics,
                id: MenuPermissionConfig.OPS_TOWER_REPORTS_DAILY_STATISTICS
            },
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.DriverPerformance, label: MenuLabel.OpsDriverPerformance,
                id: MenuPermissionConfig.OPS_TOWER_REPORTS_DRIVER_PERFORMANCE
            },
			{
				root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.TaxiDriverPerformance, label: MenuLabel.OpsTaxiDriverPerformance,
				id: MenuPermissionConfig.OPS_TOWER_REPORTS_DRIVER_PERFORMANCE, key: 'ops-tower-taxi-driver-performance'
			},
            {
                root: RootEnum.OpsTower, menuFlag: OpsTowerMenuEnum.QuestReport, label: MenuLabel.OpsQuestReport,
                id: MenuPermissionConfig.OPS_TOWER_REPORTS_QUEST_REPORT
            }
        ];
        this.addMenuItems(reportsOps, reportsItems);
    }

    addApplication() {
        const application = {
            root: RootEnum.BackOffice, label: MenuLabel.Application,
            icon: MenuIcons.Application, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE, isRoot: true
        };
        this.addMenuItems(this.model, [application]);

        const appDrivers = { label: MenuLabel.Drivers, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS };
        this.addMenuItems(application, [appDrivers]);

        const registrationBetaNew = { root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.RegistrationV2,
            label: MenuLabel.RegistrationBetaNew, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_REGISTRATION, backOffice: 0 };
        this.addMenuItems(appDrivers, [registrationBetaNew]);

        const gph = {
            root: RootEnum.BackOffice,
            menuFlag: MenuHomeEnum.Gph,
            label: MenuLabel.Gph,
            // Reuse the existing Drivers access family until a separately seeded GPH permission exists.
            id: MenuPermissionConfig.BACK_OFFICE_DRIVERS
        };
        this.addMenuItems(appDrivers, [gph]);

        const subCategoryPassenger2W = { label: MenuLabel.Passenger2W, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_2W };
        this.addMenuItems(appDrivers, [subCategoryPassenger2W]);
        const passenger2WItems = [
            {
                label: MenuLabel.DraftRegistration, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.DraftDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_2W_DRAFT_REGISTRATION,
                backOffice: BackOfficeEnum.Passenger2W
            },
            {
                label: MenuLabel.ActiveDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.ActiveDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_2W_ACTIVE_DRIVERS,
                backOffice: BackOfficeEnum.Passenger2W
            },
            {
                label: MenuLabel.CampaignDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.CompaignDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_2W_CAMPAIGN_DRIVERS,
                backOffice: BackOfficeEnum.Passenger2W
            },
            {
                label: MenuLabel.Xpress50, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.CompaignXpress50Drivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_2W_XPRESS_50,
                backOffice: BackOfficeEnum.Passenger2W
            },
            {
                label: MenuLabel.Xpress2WEV, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.Xpress2WEV, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_2W_2W_EV,
                backOffice: BackOfficeEnum.Passenger2W
            }
        ];
        this.addMenuItems(subCategoryPassenger2W, passenger2WItems);

        const subCategoryPassenger4W = { label: MenuLabel.Passenger4W, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W };
        this.addMenuItems(appDrivers, [subCategoryPassenger4W]);
        const passenger4WItems = [
            {
                label: MenuLabel.DraftRegistration, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.DraftDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_DRAFT_REGISTRATION,
                backOffice: BackOfficeEnum.Passenger4W
            },
            {
                label: MenuLabel.ActiveDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.ActiveDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_ACTIVE_DRIVERS,
                backOffice: BackOfficeEnum.Passenger4W
            },
            {
                label: MenuLabel.CampaignDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.CompaignDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_CAMPAIGN_DRIVERS,
                backOffice: BackOfficeEnum.Passenger4W
            },
            {
                label: MenuLabel.Xpress50Riders4W, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.Xpress50Riders4W, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_XPRESS_50,
                backOffice: BackOfficeEnum.Passenger4W
            },
            {
                label: MenuLabel.Xpress4WEV, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.Xpress4WEV, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_4W_EV,
                backOffice: BackOfficeEnum.Passenger4W
			},
            {
                label: MenuLabel.AllanGroup, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.AllanGroup, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_ALLAN_GROUP,
                backOffice: BackOfficeEnum.Passenger4W
            },
            {
                label: MenuLabel.NiloGroup, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.NiloGroup, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_NILO_GROUP,
                backOffice: BackOfficeEnum.Passenger4W
			},
			{
				label: MenuLabel.Xpress4WEVBataan, root: RootEnum.BackOffice,
				menuFlag: MenuHomeEnum.Xpress4WEVBataan, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W_BATAAN_EV,
				backOffice: BackOfficeEnum.Passenger4W
			}
        ];
        this.addMenuItems(subCategoryPassenger4W, passenger4WItems);

        const taxi = {
			root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.Taxi,
			label: MenuLabel.Taxi, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_TAXI, backOffice: BackOfficeEnum.Taxi
        };
        const connex = {
			root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.ConneX,
			label: MenuLabel.ConneX, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_CONNEX, backOffice: BackOfficeEnum.ConneX
        };
        this.addMenuItems(appDrivers, [taxi, connex]);

        const subCategoryDelivery2W = { label: MenuLabel.Delivery2W, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_2W };
        this.addMenuItems(appDrivers, [subCategoryDelivery2W]);
        const delivery2WItems = [
            {
                label: MenuLabel.DraftRegistration, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.DraftDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_2W_DRAFT_REGISTRATION,
                backOffice: BackOfficeEnum.Delivery2W
            },
            {
                label: MenuLabel.ActiveDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.ActiveDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_2W_ACTIVE_DRIVERS,
                backOffice: BackOfficeEnum.Delivery2W
            },
            {
                label: MenuLabel.CampaignDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.CompaignDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_2W_CAMPAIGN_DRIVERS,
                backOffice: BackOfficeEnum.Delivery2W
            },
            {
                label: MenuLabel.Xpress50, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.CompaignXpress50Drivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_2W_XPRESS_50,
                backOffice: BackOfficeEnum.Delivery2W
            },
        ];
        this.addMenuItems(subCategoryDelivery2W, delivery2WItems);

        const subCategoryDelivery4W = { label: MenuLabel.Delivery4W, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_4W };
        this.addMenuItems(appDrivers, [subCategoryDelivery4W]);
        const delivery4WItems = [
            {
                label: MenuLabel.DraftRegistration, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.DraftDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_4W_DRAFT_REGISTRATION,
                backOffice: BackOfficeEnum.Delivery4W
            },
            {
                label: MenuLabel.ActiveDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.ActiveDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_4W_ACTIVE_DRIVERS,
                backOffice: BackOfficeEnum.Delivery4W
            },
            {
                label: MenuLabel.CampaignDrivers, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.CompaignDrivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_4W_CAMPAIGN_DRIVERS,
                backOffice: BackOfficeEnum.Delivery4W
            },
            {
                label: MenuLabel.Xpress50, root: RootEnum.BackOffice,
                menuFlag: MenuHomeEnum.CompaignXpress50Drivers, id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DELIVERY_4W_XPRESS_50,
                backOffice: BackOfficeEnum.Delivery4W
            },
        ];
        this.addMenuItems(subCategoryDelivery4W, delivery4WItems);

        //operators
        const appOperators = { label: MenuLabel.Operators, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_OPERATORS };
        this.addMenuItems(application, [appOperators]);
        const operatorsItems = [
            {
                label: MenuLabel.Passenger2W, root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.OperatorsPassenger2W,
                id: MenuPermissionConfig.BACK_OFFICE_OPERATORS_PASSENGER_2W, backOffice: BackOfficeEnum.Passenger2W
            },
            {
                label: MenuLabel.Passenger4W, root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.OperatorsPassenger4W,
                id: MenuPermissionConfig.BACK_OFFICE_OPERATORS_PASSENGER_4W, backOffice: BackOfficeEnum.Passenger4W
            }
        ];
        this.addMenuItems(appOperators, operatorsItems);

        //vehicles
        const appVehicles = {
            root: RootEnum.BackOffice,
            menuFlag: MenuHomeEnum.OperatorsVehicles, label: MenuLabel.Vehicles, id: MenuPermissionConfig.BACK_OFFICE_VEHICLES
        };
		this.addMenuItems(application, [appVehicles]);

		//Taxi Vehicles
		const taxiVehicles = {
			root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.TaxiVehicles,
			label: MenuLabel.TaxiVehicles, id: MenuPermissionConfig.BACK_OFFICE_TAXI_VEHICLES
		};
		const connexVehicles = {
			root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.ConneXVehicles,
			label: MenuLabel.ConneXVehicles, id: MenuPermissionConfig.BACK_OFFICE_CONNEX_VEHICLES
		};
		this.addMenuItems(application, [taxiVehicles, connexVehicles]);

        //merchants
        const appMerchants = { label: MenuLabel.Merchants, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_MERCHANTS };
        this.addMenuItems(application, [appMerchants]);

        const appMerchantsItems = [
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.FoodOnboarding, label: MenuLabel.EatsPartner,
                id: MenuPermissionConfig.BACK_OFFICE_MERCHANTS_EATS_ALL_PARTNERS
            },
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.MartOnboarding, label: MenuLabel.MartsPartner,
                id: MenuPermissionConfig.BACK_OFFICE_MERCHANTS_MART_ALL_PARTNERS
            }
        ];

        this.addMenuItems(appMerchants, appMerchantsItems);

        //Tour Operators
        const tourOperators = {
            root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.TourOperators,
            label: MenuLabel.TourOperators, id: MenuPermissionConfig.EXPERIENCE_OPERATOR_REG
        };
        this.addMenuItems(application, [tourOperators]);

        //disciplinary
        const appDisciplinary =
            { label: MenuLabel.Disciplinary, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY };
        this.addMenuItems(application, [appDisciplinary]);

        const disciplinaryItems = [
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.DisciplinaryNewCases, label: MenuLabel.NewCases,
                items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY_NEW_CASES
            },
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.DisciplinaryInProcess, label: MenuLabel.InProcess,
                items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY_IN_PROCESS
            },
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.DisciplinaryArchived, label: MenuLabel.Archived,
                items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_DRIVERS_DISCIPLINARY_ARCHIVED
            }
        ];
        this.addMenuItems(appDisciplinary, disciplinaryItems);

        //xpress locations
        const appXpressLocations = {
            root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.DriverCenters,
            label: MenuLabel.XpressLocations, id: MenuPermissionConfig.BACK_OFFICE_XPRESS_LOCATIONS
        };
        this.addMenuItems(application, [appXpressLocations]);
        //calendar
        const appCalendary = {
            root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.Calendar,
            label: MenuLabel.Calendar, id: MenuPermissionConfig.BACK_OFFICE_CALENDAR
        };
        this.addMenuItems(application, [appCalendary]);
        //users
        const appUsers = {
            root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.Users, label: MenuLabel.Users,
            routerLink: MenuLinkEnum.Users, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE_USERS
        };
        this.addMenuItems(application, [appUsers]);

        const usersItems = [
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.SuspendedUser, label: MenuLabel.SuspendedUsers,
                id: MenuPermissionConfig.BACK_OFFICE_USERS_SUSPENDED_USERS
            },
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.BlacklistUsers, label: MenuLabel.BlacklistedUsers,
                id: MenuPermissionConfig.BACK_OFFICE_USERS_BLACKLISTED_USERS
            },
            {
                root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.CampaignUsers, label: MenuLabel.CampaignUsers,
                id: MenuPermissionConfig.BACK_OFFICE_USERS_CAMPAIGN_USERS
            }
        ];
        this.addMenuItems(appUsers, usersItems);

        //operator vehicles
        const appOperatorVehicles = {
            root: RootEnum.BackOffice,
            menuFlag: MenuHomeEnum.OperatorVehicles, label: MenuLabel.Vehicles, id: MenuPermissionConfig.BACK_OFFICE_OPERATOR_VEHICLES
        };
        this.addMenuItems(application, [appOperatorVehicles]);
    }

    addRegistration() {
        const registration = {
            root: RootEnum.RegistrationVehicles, label: MenuLabel.Registration, icon: MenuIcons.Registration,
            items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE, key: 'registration', isRoot: true
        };
        this.addMenuItems(this.model, [registration]);
        const vehicleUpgrades = {
            root: RootEnum.RegistrationVehicles, menuFlag: MenuHomeEnum.VehicleUpgrades,
            label: MenuLabel.VehicleUpgrades, id: MenuPermissionConfig.BACK_OFFICE_VEHICLES,
            key: 'registration-vehicle-upgrades',
            route: ['/xpressadmin/back-office/vehicles/upgrades']
        };
        this.addMenuItems(registration, [vehicleUpgrades]);
    }

    addLGU() {
        const lgu = {
            label: MenuLabel.LGU, icon: MenuIcons.LGU,
            id: MenuPermissionConfig.LGU, isRoot: true
        };
        this.addMenuItems(this.model, [lgu]);
    }

    addComms() {
        const comms = {
            root: RootEnum.Comms, label: MenuLabel.Comms, icon: MenuIcons.Comms,
            items: new Array<any>(), id: MenuPermissionConfig.COMMS, isRoot: true
        };
        this.addMenuItems(this.model, [comms]);

        const commsDashboard = { label: MenuLabel.Dashboard, items: new Array<any>(), id: MenuPermissionConfig.COMMS_DASHBOARD };
        this.addMenuItems(comms, [commsDashboard]);

        const dataSourceItems = [
            { root: RootEnum.Comms, label: MenuLabel.Overview, id: MenuPermissionConfig.COMMS_DASHBOARD_OVERVIEW },
            { root: RootEnum.Comms, label: MenuLabel.Facebook, id: MenuPermissionConfig.COMMS_DASHBOARD_FACEBOOK },
            { root: RootEnum.Comms, label: MenuLabel.Instagram, id: MenuPermissionConfig.COMMS_DASHBOARD_INSTAGRAM },
            { root: RootEnum.Comms, label: MenuLabel.Linkedin, id: MenuPermissionConfig.COMMS_DASHBOARD_LINKEDIN },
            { root: RootEnum.Comms, label: MenuLabel.GoogleAnalytics, id: MenuPermissionConfig.COMMS_DASHBOARD_GOOGLE_ANALYTICS },
            { root: RootEnum.Comms, label: MenuLabel.AppDownloads, id: MenuPermissionConfig.COMMS_DASHBOARD_APP_DOWNLOADS }
        ];

        this.addMenuItems(commsDashboard, dataSourceItems);

        const commsBroadcastMessage = {
            label: MenuLabel.BroadcastMessage,
            items: new Array<any>(), id: MenuPermissionConfig.COMMS_BROADCAST_MESSAGE
        };
        this.addMenuItems(comms, [commsBroadcastMessage]);

        const commsBroadcastItems = [
            {
                root: RootEnum.Comms, menuFlag: CommsMenuEnum.BroadcastMessageOperators, label: MenuLabel.Operators,
                id: MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_OPERATORS,
                route: [`/xpressadmin/comms/broadcast-message/${MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_OPERATORS}`]
            },
            {
                root: RootEnum.Comms, menuFlag: CommsMenuEnum.BroadcastMessageDrivers, label: MenuLabel.Drivers,
                id: MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_DRIVERS,
                route: [`/xpressadmin/comms/broadcast-message/${MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_DRIVERS}`]
            },
            {
                root: RootEnum.Comms, menuFlag: CommsMenuEnum.BroadcastMessageCustomers, label: MenuLabel.Customers,
                id: MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_CUSTOMERS,
                route: [`/xpressadmin/comms/broadcast-message/${MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_CUSTOMERS}`]
            }
        ];
        this.addMenuItems(commsBroadcastMessage, commsBroadcastItems);

        const commsFeedbacks = {
            root: RootEnum.Comms, menuFlag: CommsMenuEnum.Feedbacks,
            label: MenuLabel.Feedbacks, id: MenuPermissionConfig.COMMS_FEEDBACKS,
            route: [`/xpressadmin/comms/feedbacks`]
        };
        this.addMenuItems(comms, [commsFeedbacks]);

        const commsInquiries = {
            root: RootEnum.Comms, menuFlag: CommsMenuEnum.Inquiries,
            label: MenuLabel.Inquiries, id: MenuPermissionConfig.BACK_OFFICE,
            key: 'comms-inquiries',
            route: [`/xpressadmin/comms/inquiries`]
        };

        this.addMenuItems(comms, [commsInquiries]);

    }

    addReports() {
        const reports = {
            root: RootEnum.Report, label: MenuLabel.Reports,
            icon: MenuIcons.Reports, items: new Array<any>(), id: MenuPermissionConfig.REPORT, isRoot: true
        };
        this.addMenuItems(this.model, [reports]);

        const reportsItems = [
            {
                root: RootEnum.Report, menuFlag: SideMenuReportEnum.Drivers,
				label: MenuLabel.ReportDrivers, id: MenuPermissionConfig.REPORT_DRIVERS,
				route: ['/xpressadmin/report/drivers']
            },
            {
                root: RootEnum.Report, menuFlag: SideMenuReportEnum.Customers,
				label: MenuLabel.ReportCustomers, id: MenuPermissionConfig.REPORT_CUSTOMERS,
				route: ['/xpressadmin/report/customers']
            },
            {
                root: RootEnum.Report, menuFlag: SideMenuReportEnum.Revenue,
				label: MenuLabel.ReportRevenue, id: MenuPermissionConfig.REPORT_REVENUE,
				route: ['/xpressadmin/report/revenue']
            },
            {
                root: RootEnum.Report, menuFlag: SideMenuReportEnum.Disbursements,
                label: MenuLabel.ReportDisbursements, id: MenuPermissionConfig.REPORT_DISBURSEMENTS,
				route: ['/xpressadmin/report/disbursements']
            }
        ];
        this.addMenuItems(reports, reportsItems);
    }

    addMarketing() {
        const marketing = {
            root: RootEnum.Marketing, label: MenuLabel.Marketing,
            icon: MenuIcons.Marketing, items: new Array<any>(), id: MenuPermissionConfig.MARKETING, isRoot: true
        };
        this.addMenuItems(this.model, [marketing]);

        const marketingDashboard = {
            label: MenuLabel.Dashboard, items: new Array<any>(),
            id: MenuPermissionConfig.MARKETING_DASHBOARD
        };
        this.addMenuItems(marketing, [marketingDashboard]);

        const dataSourceItems = [
            { root: RootEnum.Marketing, label: MenuLabel.Overview, id: MenuPermissionConfig.MARKETING_DASHBOARD_OVERVIEW },
            { root: RootEnum.Marketing, label: MenuLabel.Facebook, id: MenuPermissionConfig.MARKETING_DASHBOARD_FACEBOOK },
            { root: RootEnum.Marketing, label: MenuLabel.Instagram, id: MenuPermissionConfig.MARKETING_DASHBOARD_INSTAGRAM },
            { root: RootEnum.Marketing, label: MenuLabel.Linkedin, id: MenuPermissionConfig.MARKETING_DASHBOARD_LINKEDIN },
            { root: RootEnum.Marketing, label: MenuLabel.GoogleAnalytics, id: MenuPermissionConfig.MARKETING_DASHBOARD_GOOGLE_ANALYTICS },
            { root: RootEnum.Marketing, label: MenuLabel.AppDownloads, id: MenuPermissionConfig.MARKETING_DASHBOARD_APP_DOWNLOADS }
        ];
        this.addMenuItems(marketingDashboard, dataSourceItems);

        const offlineMarketing = {
            label: MenuLabel.OfflineMarketing, items: new Array<any>(),
            id: MenuPermissionConfig.MARKETING_OFFLINE_MARKETING
        };
        this.addMenuItems(marketing, [offlineMarketing]);

        const offlineMarketingItems = [
            {
                root: RootEnum.Marketing, label: MenuLabel.Campaigns,
                id: MenuPermissionConfig.MARKETING_OFFLINE_MARKETING_CAMPAIGNS
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.Ambassadors,
                id: MenuPermissionConfig.MARKETING_OFFLINE_MARKETING_AMBASSADORS
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.Influencers,
                id: MenuPermissionConfig.MARKETING_OFFLINE_MARKETING_INFLUENCERS
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.Marketing3rdPartyCompany,
                id: MenuPermissionConfig.MARKETING_OFFLINE_3RD_PARTY_COMPANY
            }
        ];
        this.addMenuItems(offlineMarketing, offlineMarketingItems);

        const eventsMarketing = { label: MenuLabel.Events, items: new Array<any>(), id: MenuPermissionConfig.MARKETING_EVENTS };
        this.addMenuItems(marketing, [eventsMarketing]);

        const marketingEventsItems = [
            {
                root: RootEnum.Marketing, label: MenuLabel.DriverActivation,
                id: MenuPermissionConfig.MARKETING_EVENTS_DRIVER_ACTIVATION
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.UserActivation,
                id: MenuPermissionConfig.MARKETING_EVENTS_USER_ACTIVATION
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.MerchantActivation,
                id: MenuPermissionConfig.MARKETING_EVENTS_MERCHANT_ACTIVATION
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.EmployeeEvent,
                id: MenuPermissionConfig.MARKETING_EVENTS_EMPLOYEE_EVENT
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.DriverTraining,
                id: MenuPermissionConfig.MARKETING_EVENTS_DRIVER_TRAINING
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.OtherEvents,
                id: MenuPermissionConfig.MARKETING_EVENTS_OTHER_EVENTS
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.Assets,
                id: MenuPermissionConfig.MARKETING_EVENTS_ASSETS
            },
            {
                root: RootEnum.Marketing, label: MenuLabel.MarketingMaterial,
                id: MenuPermissionConfig.MARKETING_EVENTS_MARKETING_MATERIAL
            }
        ];
        this.addMenuItems(eventsMarketing, marketingEventsItems);

        //Xpress App Marketing
        const xappMarketing = {
            label: MenuLabel.XpressAppMarketing, items: new Array<any>(),
            id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING
        };
        this.addMenuItems(marketing, [xappMarketing]);

        //promotions
        const xappMarketingPromotions = {
            label: MenuLabel.Promotions, items: new Array<any>(),
            id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS
        };
        this.addMenuItems(xappMarketing, [xappMarketingPromotions]);
        const xappMarketingPromoItems: any[] = [
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.AllPromotions, label: MenuLabel.MarketingAllPromotions,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_ALL_PROMOTIONS
            },
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.PromotionMaterials, label: MenuLabel.PromotionMaterials,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_ALL_PROMOTIONS,
                key: 'marketing-promotion-materials'
            },
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.PromotionsPerformance, label: MenuLabel.Perfomance,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_PERFORMANCE
            },
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.DiscountsReport, label: MenuLabel.DiscountsReport,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_DISCOUNTSREPORT
			},
			{
				root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.ReferralReport, label: MenuLabel.ReferralReport,
				id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_REFERRAL_REPORT
			},
			{
				root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.PromoBudgets, label: MenuLabel.PromoBudgets,
				id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_ALL_PROMOTIONS,
                key: 'marketing-promo-budgets'
			},
			{
				root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.PromoSponsors, label: MenuLabel.PromoSponsors,
				id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_ALL_PROMOTIONS,
                key: 'marketing-promo-sponsors'
			}
        ];
        this.addMenuItems(xappMarketingPromotions, xappMarketingPromoItems);

        //advertisements
        const advertisements = { label: MenuLabel.Advertisements, items: new Array<any>(), id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_ADVERTISEMENTS };
        this.addMenuItems(xappMarketing, [advertisements]);

        const marketingAdvertisements = [
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.AllCampaigns, label: MenuLabel.AllCampaigns,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_ADVERTISEMENTS_ALL_CAMPAIGNS
            },
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.AdvertisementsPerformance, label: MenuLabel.Perfomance,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_ADVERTISEMENTS_PERFORMANCE
            },
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.AdvertisementsSettings, label: MenuLabel.Settings,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_ADVERTISEMENTS_SETTINGS
            }
        ];
        this.addMenuItems(advertisements, marketingAdvertisements);

        //customer quest
        const customerQuest = {
            root: RootEnum.Marketing, label: MenuLabel.CustomerQuest,
            menuFlag: MarketingMenuEnum.CustomerQuest, id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_CUSTOMER_QUEST
        };
        this.addMenuItems(xappMarketing, [customerQuest]);

        //driver quest
        const incentiveQuest = {
            root: RootEnum.Marketing, label: MenuLabel.IncentiveQuest,
            menuFlag: MarketingMenuEnum.IncentiveQuest, id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_CUSTOMER_QUEST,
            key: 'marketing-incentive-quest'
        };
        this.addMenuItems(xappMarketing, [incentiveQuest]);

        //Integration
        const integration = {
            root: RootEnum.Marketing, label: MenuLabel.Integration,
            routerLink: MenuLinkEnum.Integrations, id: MenuPermissionConfig.MARKETING_INTEGRATIONS
        };
        this.addMenuItems(marketing, [integration]);
    }

    addMarketingDumaguete() {
        const marketing = {
            root: RootEnum.Marketing, label: MenuLabel.Marketing,
            icon: MenuIcons.Marketing, items: new Array<any>(), id: MenuPermissionConfig.MARKETING, isRoot: true
        };
        this.addMenuItems(this.model, [marketing]);

        const xappMarketing = {
            label: MenuLabel.XpressAppMarketing, items: new Array<any>(),
            id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING
        };
        this.addMenuItems(marketing, [xappMarketing]);

        const xappMarketingPromotions = {
            label: MenuLabel.Promotions, items: new Array<any>(),
            id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS
        };
        this.addMenuItems(xappMarketing, [xappMarketingPromotions]);

        const xappMarketingPromoItems = [
            {
                root: RootEnum.Marketing, menuFlag: MarketingMenuEnum.AllPromotions, label: MenuLabel.MarketingAllPromotions,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_ALL_PROMOTIONS
            }
        ];
        this.addMenuItems(xappMarketingPromotions, xappMarketingPromoItems);
    }

    addFinance() {
        const finance = {
            root: RootEnum.Finances, label: MenuLabel.Finance, icon: MenuIcons.Finance,
            items: new Array<any>(), id: MenuPermissionConfig.FINANCE, isRoot: true
        };
        this.addMenuItems(this.model, [finance]);

        const financeDashboard = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.Dashboard,
            label: MenuLabel.Dashboard, routerLink: MenuLinkEnum.FinancesDashboard, id: MenuPermissionConfig.FINANCE_DASHBOARD,
            route: ['/xpressadmin/finance/dashboard']
        };
        this.addMenuItems(finance, [financeDashboard]);

        // const financeCommerce = {
        //     root: RootEnum.Finances, menuFlag: FinanceMenuEnum.Commerce,
        //     label: MenuLabel.Commerce, routerLink: MenuLinkEnum.Commerce, id: MenuPermissionConfig.FINANCE_INVENTORY
        // };
        // this.addMenuItems(finance, [financeCommerce]);

        const financeRevenue = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.Revenue,
            label: MenuLabel.Revenue, routerLink: MenuLinkEnum.Revenue, id: MenuPermissionConfig.FINANCE_REVENUE,
            route: ['/xpressadmin/finance/revenue']
        };
        this.addMenuItems(finance, [financeRevenue]);

        const financeCustomerWallet = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.CustomerWallet,
            label: MenuLabel.CustomerWallet, id: MenuPermissionConfig.FINANCE_CUSTOMER_XPAY_WALLET,
            route: ['/xpressadmin/finance/customer-wallet']
        };
        this.addMenuItems(finance, [financeCustomerWallet]);

        const financeDriverWallet = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.DriverWallet,
            label: MenuLabel.DriverWallet, id: MenuPermissionConfig.FINANCE_DRIVER_WALLET,
            route: ['/xpressadmin/finance/driver-wallet']
        };
        const financeDriverCommerce = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.DriverCommerce,
            label: MenuLabel.DriverCommerce, id: MenuPermissionConfig.FINANCE_DRIVER_COMMERCE,
            route: ['/xpressadmin/finance/driver-commerce']
        };
        const financeCustomerCommerce = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.CustomerCommerce,
            label: MenuLabel.CustomerCommerce, id: MenuPermissionConfig.FINANCE_CUSTOMER_COMMERCE,
            route: ['/xpressadmin/finance/customer-commerce']
        };
        this.addMenuItems(finance, [financeDriverWallet]);
        this.addMenuItems(finance, [financeDriverCommerce, financeCustomerCommerce]);

        const financeCollection = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.Collection,
            label: MenuLabel.Collection, id: MenuPermissionConfig.FINANCE_COLLECTION,
            route: ['/xpressadmin/finance/collection']
        };
        this.addMenuItems(finance, [financeCollection]);

        const financeAccounting = { label: MenuLabel.Accounting, items: new Array<any>(), id: MenuPermissionConfig.FINANCE_ACCOUNTING };
        this.addMenuItems(finance, [financeAccounting]);

        const financeAccountingItems = [
            {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.AccountingDashboard, label: MenuLabel.Dashboard,
                routerLink: MenuLinkEnum.Accounting, id: MenuPermissionConfig.FINANCE_ACCOUNTING_DASHBOARD,
                route: ['/xpressadmin/finance/accounting/dashboard']
            },
            {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.AccountingPayout, label: MenuLabel.Payout,
                routerLink: MenuLinkEnum.Accounting, id: MenuPermissionConfig.FINANCE_ACCOUNTING_PAYOUT,
                route: ['/xpressadmin/finance/accounting/payout']
            },
            {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.AccountingCashflowSummary, label: MenuLabel.CashflowSummary,
                routerLink: MenuLinkEnum.Accounting, id: MenuPermissionConfig.FINANCE_ACCOUNTING_CASHFLOW_SUMMARY,
                route: ['/xpressadmin/finance/accounting/cashflow-summary']
            },
            {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.XenditTransactions, label: MenuLabel.XenditTransactions,
                routerLink: MenuLinkEnum.Accounting, id: MenuPermissionConfig.FINANCE_ACCOUNTING_XENDIT_TRANSACTIONS,
                route: ['/xpressadmin/finance/accounting/xendit-transactions']
            }
        ];
        this.addMenuItems(financeAccounting, financeAccountingItems);

        const financeInventory = {
            root: RootEnum.Finances, menuFlag: FinanceMenuEnum.Inventory,
            label: MenuLabel.Inventory, routerLink: MenuLinkEnum.Inventory, id: MenuPermissionConfig.FINANCE_INVENTORY,
            route: ['/xpressadmin/finance/inventory']
        };
        this.addMenuItems(finance, [financeInventory]);

        // const guaranteedPay = { root: RootEnum.Finances, //menuFlag: FinanceMenuEnum.GuaranteedPay,
        //     label: MenuLabel.GuaranteedPay, routerLink: MenuLinkEnum.Inventory, id: MenuPermissionConfig.FINANCE_GUARANTEEDPAY };
        // this.addMenuItems(finance, [guaranteedPay]);
        //
        // const topUps = { root: RootEnum.Finances, menuFlag: FinanceMenuEnum.TopUps,
        //     label: MenuLabel.TopUps, routerLink: MenuLinkEnum.Inventory, id: MenuPermissionConfig.FINANCE_TOPUPS };
        // this.addMenuItems(finance, [topUps]);
        //
        // const cashOut = { root: RootEnum.Finances, menuFlag: FinanceMenuEnum.CashOut,
        //     label: MenuLabel.CashOut, routerLink: MenuLinkEnum.Inventory, id: MenuPermissionConfig.FINANCE_CASHOUT };
        // this.addMenuItems(finance, [cashOut]);

        if (this.appData.isBoracayLocation || this.appData.isDumagueteLocation) {
            const financePayout = {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.Revenue,
                label: MenuLabel.Payout, routerLink: MenuLinkEnum.Revenue, id: MenuPermissionConfig.FINANCE_PAYOUT,
                route: ['/xpressadmin/finance/payout']
            };
            this.addMenuItems(finance, [financePayout]);

            const financeInvoices = {
                root: RootEnum.Finances, menuFlag: FinanceMenuEnum.Revenue,
                label: MenuLabel.Invoices, routerLink: MenuLinkEnum.Revenue, id: MenuPermissionConfig.FINANCE_INVOICES,
                route: ['/xpressadmin/finance/invoices']
            };
            this.addMenuItems(finance, [financeInvoices]);
        }
    }

    addSettings() {

        const settings = {
            root: RootEnum.Settings, menuFlag: SettingsMenuEnum.SystemFlags,
            label: MenuLabel.Settings,
            icon: MenuIcons.Settings,
            items: new Array<any>(), id: MenuPermissionConfig.SETTINGS, isRoot: true,
            routerLink: ['/xpressadmin/settings'],
            route: ['/xpressadmin/settings']
        };
        this.addMenuItems(this.model, [settings]);

        //system status
        const settingsSystemStatus = {
            label: MenuLabel.SystemStatus,
            id: MenuPermissionConfig.SETTINGS_SYSTEM_STATUS, items: new Array<any>()
        };
        this.addMenuItems(settings, [settingsSystemStatus]);

        const systemStatusItems = [
            { root: RootEnum.Settings, label: MenuLabel.Overview, id: MenuPermissionConfig.SETTINGS_SYSTEM_STATUS_OVERVIEW },
            { root: RootEnum.Settings, label: MenuLabel.Playstore, id: MenuPermissionConfig.SETTINGS_SYSTEM_STATUS_PLAYSTORE },
            { root: RootEnum.Settings, label: MenuLabel.AppStore, id: MenuPermissionConfig.SETTINGS_SYSTEM_STATUS_APP_STORE }
        ];
        this.addMenuItems(settingsSystemStatus, systemStatusItems);

        //user management
        const userManagement = {
            label: MenuLabel.UserManagement, id: MenuPermissionConfig.SETTINGS_USER_MANAGMENT,
            items: new Array<any>()
        };
        this.addMenuItems(settings, [userManagement]);

        const userManagementItems = [
            {
                root: RootEnum.Settings, menuFlag: SettingsMenuEnum.UserManagmentAllUsers, label: MenuLabel.AllUsers,
                routerLink: MenuLinkEnum.AllUsers,
                id: MenuPermissionConfig.SETTINGS_USER_MANAGMENT_ALL_USERS,
                route: [`/xpressadmin/settings/user-management/${MenuPermissionConfig.SETTINGS_USER_MANAGMENT_ALL_USERS}`]
            },
            {
                root: RootEnum.Settings, menuFlag: SettingsMenuEnum.UserManagmentRoles, label: MenuLabel.Roles,
                routerLink: MenuLinkEnum.Roles, id: MenuPermissionConfig.SETTINGS_USER_MANAGMENT_ROLES,
                route: [`/xpressadmin/settings/user-management/${MenuPermissionConfig.SETTINGS_USER_MANAGMENT_ROLES}`]
            }
        ];
        this.addMenuItems(userManagement, userManagementItems);

        //maps
        const maps =
        {
            label: MenuLabel.Maps,
            id: MenuPermissionConfig.SETTINGS_MAPS,
            items: new Array<any>(),
        };
        this.addMenuItems(settings, [maps]);

        const mapsItems =
        [
            {
                root: RootEnum.Settings,
                menuFlag: SettingsMenuEnum.MapsRegionMapEditor,
                label: MenuLabel.RegionMapEditor,
                id: MenuPermissionConfig.SETTINGS_MAPS_REGION_MAP_EDITOR,
                route: [`/xpressadmin/settings/maps/${MenuPermissionConfig.SETTINGS_MAPS_REGION_MAP_EDITOR}`]
            }
        ];
        this.addMenuItems(maps, mapsItems);

        //security
        const security = { label: MenuLabel.Security, id: MenuPermissionConfig.SETTINGS_SECURITY, items: new Array<any>() };
        this.addMenuItems(settings, [security]);
        const settingsSecurityItems: Array<{ root: RootEnum; label: string; id: string; key?: string }> = [
            { root: RootEnum.Settings, label: MenuLabel.PasswordManagement, id: MenuPermissionConfig.SETTINGS_SECURITY, key: 'settings-security-password-management' },
            { root: RootEnum.Settings, label: MenuLabel.UserAudit, id: MenuPermissionConfig.SETTINGS_SECURITY_USER_AUDIT },
            { root: RootEnum.Settings, label: MenuLabel.PlatformAlerts, id: MenuPermissionConfig.SETTINGS_SECURITY_PLATFORM_ALERS },
            { root: RootEnum.Settings, label: MenuLabel.SuspiciousActivities, id: MenuPermissionConfig.SETTINGS_SECURITY_SUSPICIOUS_ACTIVITIES }
        ];
        this.addMenuItems(security, settingsSecurityItems);

        //vehicle and fares
        const vehicleAndFares = { label: MenuLabel.VehicleAndFares, id: MenuPermissionConfig.SETTINGS_VEHICLE_AND_FARES, items: new Array<any>() };
        this.addMenuItems(settings, [vehicleAndFares]);
        const vehicle = {
            root: RootEnum.Settings, label: MenuLabel.Vehicle,
            id: MenuPermissionConfig.SETTINGS_VEHICLE_AND_FARES_VEHICLE
        };
        this.addMenuItems(vehicleAndFares, [vehicle]);

        //coding
        const coding = { label: MenuLabel.Coding, id: MenuPermissionConfig.SETTINGS_CODING, items: new Array<any>() };
        this.addMenuItems(settings, [coding]);

        const settingsCodingItems = [
            { root: RootEnum.Settings, label: MenuLabel.ETrike, id: MenuPermissionConfig.SETTINGS_CODING_ETRIKE },
            { root: RootEnum.Settings, label: MenuLabel.Multicab, id: MenuPermissionConfig.SETTINGS_CODING_MULTICAB },
            { root: RootEnum.Settings, label: MenuLabel.Van, id: MenuPermissionConfig.SETTINGS_CODING_VAN },
            { root: RootEnum.Settings, label: MenuLabel.Minibus, id: MenuPermissionConfig.SETTINGS_CODING_MINIBUS }
        ];
        this.addMenuItems(coding, settingsCodingItems);
    }

    addAudit() {
        const audit = {
            root: RootEnum.Audit, label: MenuLabel.Audit,
            icon: MenuIcons.Audit, items: new Array<any>(), id: MenuPermissionConfig.AUDIT, isRoot: true,
        };
        // this.addMenuItems(this.model, [audit]);

        const auditItems = [
            audit,
            {
                root: RootEnum.Audit,
                label: MenuLabel.Verification,
                id: MenuPermissionConfig.AUDIT_VERIFICATION },
            {
                root: RootEnum.Audit,
                menuFlag: MenuHomeEnum.ApplicationAudit,
                label: MenuLabel.ApplicationAudit,
                id: MenuPermissionConfig.AUDIT_APPLICATION_AUDIT,
                route: ['/xpressadmin/audit/application-audit']
            },
            { root: RootEnum.Audit, label: MenuLabel.AuditHistory, id: MenuPermissionConfig.AUDIT_AUDIT_HISTORY },
            { root: RootEnum.Audit, label: MenuLabel.Reports, id: MenuPermissionConfig.AUDIT_REPORTS }
        ];
        this.addMenuItems(audit, auditItems);
    }

    addPartnerHome() {
        const partnerHome = {
            root: RootEnum.PartnerHome,
            label: MenuLabel.Home, routerLink: MenuLinkEnum.PartnerDashboard, icon: PartnerMenuIcons.Home, menuFlag: MenuHomeEnum.PartnerDashboard,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_HOME_DASHBOARD, isRoot: true, activeMenu: 'dashboard'
        };
        this.addMenuItems(this.model, [partnerHome]);
        const partnerHomeItems = [
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.PartnerDashboard, label: MenuLabel.Dashboard,
                routerLink: MenuLinkEnum.PartnerDashboard, id: MenuPermissionConfig.PARTNER_HOME_DASHBOARD, activeMenu: 'dashboard'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.PartnerCatalogue, label: MenuLabel.Catalogue,
                routerLink: MenuLinkEnum.PartnerCatalogue, id: MenuPermissionConfig.PARTNER_HOME_CATALOGUE, activeMenu: 'catalogue'
            }
        ];
        this.addMenuItems(partnerHome, partnerHomeItems);

        const partnerEmployees = {
            label: MenuLabel.Employees, items: new Array<any>(),
            id: MenuPermissionConfig.PARTNER_HOME_EMPLOYEES,
            activeMenu: 'employees'
        };
        this.addMenuItems(partnerHome, [partnerEmployees]);
        const partnerEmployeesItems = [
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.StoreEmployees, label: MenuLabel.StoreEmployees,
                id: MenuPermissionConfig.PARTNER_HOME_EMPLOYEES_STORE_EMPLOYEES, activeMenu: 'employees'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.PartnerEmployees, label: MenuLabel.PartnerEmployees,
                id: MenuPermissionConfig.PARTNER_HOME_EMPLOYEES_PARTNER_EMPLOYEES, activeMenu: 'employees'
            }
        ];
        this.addMenuItems(partnerEmployees, partnerEmployeesItems);

        const partnerInventory = {
            label: MenuLabel.Inventory, items: new Array<any>(),
            id: MenuPermissionConfig.PARTNER_HOME_INVENTORY, activeMenu: 'inventory'
        };
        this.addMenuItems(partnerHome, [partnerInventory]);
        const partnerInventoryItems = [
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.AllProducts, label: MenuLabel.AllProducts,
                id: MenuPermissionConfig.PARTNER_HOME_INVENTORY_ALL_PRODUCTS, activeMenu: 'inventory'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.Categories, label: MenuLabel.Categories,
                id: MenuPermissionConfig.PARTNER_HOME_INVENTORY_CATEGORIES, activeMenu: 'inventory'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.Bundles, label: MenuLabel.Bundles,
                id: MenuPermissionConfig.PARTNER_HOME_INVENTORY_BUNDLES, activeMenu: 'inventory'
            }
        ];
        this.addMenuItems(partnerInventory, partnerInventoryItems);

        const partnerFinance = {
            label: MenuLabel.Finance, items: new Array<any>(),
            id: MenuPermissionConfig.PARTNER_HOME_FINANCE, activeMenu: 'finance'
        };
        this.addMenuItems(partnerHome, [partnerFinance]);
        const partnerFinanceItems = [
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.Transactions, label: MenuLabel.Transactions,
                id: MenuPermissionConfig.PARTNER_HOME_FINANCE_TRANSACTIONS, activeMenu: 'finance'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.Payouts, label: MenuLabel.Payouts,
                id: MenuPermissionConfig.PARTNER_HOME_FINANCE_PAYOUTS, activeMenu: 'finance'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.NextPayout, label: MenuLabel.NextPayout,
                id: MenuPermissionConfig.PARTNER_HOME_FINANCE_NEXT_PAYOUT, activeMenu: 'finance'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.Invoices, label: MenuLabel.Invoices,
                id: MenuPermissionConfig.PARTNER_HOME_FINANCE_INVOICES, activeMenu: 'finance'
            }
        ];
        this.addMenuItems(partnerFinance, partnerFinanceItems);

        const partnerAppConfig = {
            label: MenuLabel.AppConfig, items: new Array<any>(),
            id: MenuPermissionConfig.PARTNER_HOME_APP_CONFIG, activeMenu: 'config'
        };
        this.addMenuItems(partnerHome, [partnerAppConfig]);
        const partnerAppConfigItems = [
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.StoreIdentity, label: MenuLabel.StoreIdentity,
                id: MenuPermissionConfig.PARTNER_HOME_APP_CONFIG_STORE_IDENTITY, activeMenu: 'config'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.RecommendedProducts, label: MenuLabel.RecommendedProducts,
                id: MenuPermissionConfig.PARTNER_HOME_APP_CONFIG_RECOMMENDED_PRODUCTS, activeMenu: 'config'
            },
            {
                root: RootEnum.PartnerHome, menuFlag: MenuHomeEnum.CategoryOrder, label: MenuLabel.CategoryOrder,
                id: MenuPermissionConfig.PARTNER_HOME_APP_CONFIG_CATEGORY_ORDER, activeMenu: 'config'
            }
        ];
        this.addMenuItems(partnerAppConfig, partnerAppConfigItems);
    }

    addPartnerOrders() {
        const partnerOrders = {
            root: RootEnum.PartnerOrders,
            label: MenuLabel.Orders, routerLink: MenuHomeEnum.AllOrder, icon: PartnerMenuIcons.Orders, menuFlag: MenuHomeEnum.AllOrder,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_ORDERS_ALL_ORDERS, isRoot: true, activeMenu: 'orders'
        };
        this.addMenuItems(this.model, [partnerOrders]);
        const partnerOrderItems = [
            {
                root: RootEnum.PartnerOrders, menuFlag: MenuHomeEnum.AllOrder, label: MenuLabel.AllOrders,
                routerLink: MenuLinkEnum.AllOrders, id: MenuPermissionConfig.PARTNER_ORDERS_ALL_ORDERS, activeMenu: 'orders'
            },
            {
                root: RootEnum.PartnerOrders, menuFlag: MenuHomeEnum.Feedback, label: MenuLabel.Feedback,
                routerLink: MenuLinkEnum.Feedback, id: MenuPermissionConfig.PARTNER_ORDERS_FEEDBACK, activeMenu: 'feedback'
            }
        ];
        this.addMenuItems(partnerOrders, partnerOrderItems);
    }

    addPartnerLocations() {
        const partnerLocations = {
            root: RootEnum.PartnerLocations,
            label: MenuLabel.Store, routerLink: MenuLinkEnum.Locations, menuFlag: MenuHomeEnum.Stores, icon: PartnerMenuIcons.Locations,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_LOCATIONS, isRoot: true, activeMenu: 'locations'
        };

        this.addMenuItems(this.model, [partnerLocations]);

        const locationItems = [
            {
                root: RootEnum.PartnerLocations, menuFlag: MenuLinkEnum.Locations, label: MenuLabel.Locations,
                routerLink: MenuLinkEnum.Locations, id: MenuPermissionConfig.PARTNER_LOCATIONS, activeMenu: 'locations'
            }
        ];
        this.addMenuItems(partnerLocations, locationItems);
    }

    addPartnerMenu() {
        const partnerMenu = {
            root: RootEnum.PartnerMenu,
            label: MenuLabel.Menu, routerLink: MenuLinkEnum.Locations, menuFlag: MenuHomeEnum.Stores, icon: PartnerMenuIcons.Menu,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_LOCATIONS, isRoot: true, activeMenu: 'menu'
        };

        this.addMenuItems(this.model, [partnerMenu]);
    }

    addPartnerHelp() {
        const partnerMenu = {
            root: RootEnum.PartnerMenu,
            label: MenuLabel.Help, routerLink: MenuLinkEnum.Locations, menuFlag: MenuHomeEnum.Stores, icon: PartnerMenuIcons.Help,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_LOCATIONS, isRoot: true, activeMenu: 'help'
        };

        this.addMenuItems(this.model, [partnerMenu]);
    }

    addPartnerMarketing() {
        const partnerMarketing = {
            root: RootEnum.PartnerMarketing,
            label: MenuLabel.Marketing, routerLink: MenuLinkEnum.Marketing, icon: PartnerMenuIcons.Marketing,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_MARKETING, isRoot: true, activeMenu: 'marketing'
        };
        this.addMenuItems(this.model, [partnerMarketing]);

        const partnerPromotions = {
            label: MenuLabel.Promotions, items: new Array<any>(),
            id: MenuPermissionConfig.PARTNER_MARKETING_PROMOTIONS, activeMenu: 'promotions'
        };
        this.addMenuItems(partnerMarketing, [partnerPromotions]);
        const partnerPromotionsItems = [
            {
                root: RootEnum.PartnerMarketing, menuFlag: MenuHomeEnum.AllPromotions, label: MenuLabel.AllPromotions,
                id: MenuPermissionConfig.PARTNER_MARKETING_PROMOTIONS_ALL_PROMOTIONS, activeMenu: 'promotions'
            },
            {
                root: RootEnum.PartnerMarketing, menuFlag: MenuHomeEnum.Performance, label: MenuLabel.Performance,
                id: MenuPermissionConfig.PARTNER_MARKETING_PROMOTIONS_PERFORMANCE, activeMenu: 'promotions'
            },
            {
                root: RootEnum.PartnerMarketing, menuFlag: MenuHomeEnum.RecommendeedPromo, label: MenuLabel.RecommendedPromo,
                id: MenuPermissionConfig.PARTNER_MARKETING_PROMOTIONS_RECOMMENDED_PROMO, activeMenu: 'promotions'
            },
            {
                root: RootEnum.PartnerMarketing, menuFlag: MarketingMenuEnum.DiscountsReport, label: MenuLabel.DiscountsReport,
                id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_DISCOUNTSREPORT, activeMenu: 'promotions'
			},
			{
				root: RootEnum.PartnerMarketing, menuFlag: MarketingMenuEnum.ReferralReport, label: MenuLabel.ReferralReport,
				id: MenuPermissionConfig.MARKETING_XPRESS_APP_MARKETING_PROMOTIONS_REFERRAL_REPORT, activeMenu: 'promotions'
			}
        ];
        this.addMenuItems(partnerPromotions, partnerPromotionsItems);

        const partnerAdvertisements = {
            label: MenuLabel.Promotions, items: new Array<any>(),
            id: MenuPermissionConfig.PARTNER_MARKETING_ADVERTISEMENTS, activeMenu: 'advertisements'
        };
        this.addMenuItems(partnerMarketing, [partnerAdvertisements]);
        const partnerAdvertisementsItems = [
            {
                root: RootEnum.PartnerMarketing, menuFlag: MenuHomeEnum.Campaigns, label: MenuLabel.Campaigns,
                id: MenuPermissionConfig.PARTNER_MARKETING_ADVERTISEMENTS_CAMPAIGNS, activeMenu: 'advertisements'
            },
            {
                root: RootEnum.PartnerMarketing, menuFlag: MenuHomeEnum.Performance, label: MenuLabel.Performance,
                id: MenuPermissionConfig.PARTNER_MARKETING_ADVERTISEMENTS_PERFORMANCE, activeMenu: 'advertisements'
            },
            {
                root: RootEnum.PartnerMarketing, menuFlag: MenuHomeEnum.CreateCampaign, label: MenuLabel.CreateCampaign,
                id: MenuPermissionConfig.PARTNER_MARKETING_ADVERTISEMENTS_CREATE_CAMPAIGN, activeMenu: 'advertisements'
            }
        ];
        this.addMenuItems(partnerAdvertisements, partnerAdvertisementsItems);
    }

    addPartnerFinanceReports() {
        const partnerFinanceReports = {
            root: RootEnum.PartnerFinanceReports,
            label: MenuLabel.Finance, routerLink: MenuLinkEnum.PartnerFinance, menuFlag: MenuHomeEnum.FinanceReports, icon: PartnerMenuIcons.Finance,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_HOME_FINANCE, isRoot: true, activeMenu: 'finance'
        };

        this.addMenuItems(this.model, [partnerFinanceReports]);
    }

    addPartnerInsights() {
        const partnerInsights = {
            root: RootEnum.PartnerInsights,
            label: MenuLabel.Insights, routerLink: MenuLinkEnum.Insights, icon: PartnerMenuIcons.Insights,menuFlag: MenuHomeEnum.Overview,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_INSIGHTS, isRoot: true, activeMenu: 'insights'
        };
        this.addMenuItems(this.model, [partnerInsights]);
        const partnerInsightsItems = [
            {
                root: RootEnum.PartnerInsights, menuFlag: MenuHomeEnum.Overview, label: MenuLabel.Overview,
                id: MenuPermissionConfig.PARTNER_INSIGHTS_OVERVIEW, activeMenu: 'overview'
            },
            {
                root: RootEnum.PartnerInsights, menuFlag: MenuHomeEnum.Operations, label: MenuLabel.Operations,
                id: MenuPermissionConfig.PARTNER_INSIGHTS_OPERATIONS, activeMenu: 'operations'
            },
            {
                root: RootEnum.PartnerInsights, menuFlag: MenuHomeEnum.Products, label: MenuLabel.Products,
                id: MenuPermissionConfig.PARTNER_INSIGHTS_PRODUCTS, activeMenu: 'products'
            },
            {
                root: RootEnum.PartnerInsights, menuFlag: MenuHomeEnum.Customers, label: MenuLabel.Customers,
                id: MenuPermissionConfig.PARTNER_INSIGHTS_CUSTOMERS, activeMenu: 'customers'
            },
            {
                root: RootEnum.PartnerInsights, menuFlag: MenuHomeEnum.Reviews, label: MenuLabel.Reviews,
                id: MenuPermissionConfig.PARTNER_INSIGHTS_REVIEWS, activeMenu: 'reviews'
            }
        ];
        this.addMenuItems(partnerInsights, partnerInsightsItems);
    }

    addPartnerSettings() {
        const partnerSettings = {
            root: RootEnum.PartnerSettings,
            label: MenuLabel.Settings, routerLink: MenuLinkEnum.PartnerAppConfig, icon: PartnerMenuIcons.Settings, menuFlag: MenuHomeEnum.StoreIdentity,
            items: new Array<any>(), id: MenuPermissionConfig.PARTNER_SETTINGS, isRoot: true, activeMenu: 'settings'
        };
        this.addMenuItems(this.model, [partnerSettings]);

        const partnerBusinessInfo = {
            label: MenuLabel.BusinessInfo, items: new Array<any>(),
            id: MenuPermissionConfig.PARTNER_SETTINGS_BUSINESS_INFO, activeMenu: 'info'
        };
        this.addMenuItems(partnerSettings, [partnerBusinessInfo]);
        const partnerBusinessInfoItems = [
            {
                root: RootEnum.PartnerSettings, menuFlag: MenuHomeEnum.BusinessInfo, label: MenuLabel.BusinessInfo,
                id: MenuPermissionConfig.PARTNER_SETTINGS_BUSINESS_INFO, activeMenu: 'info'
            },
            {
                root: RootEnum.PartnerSettings, menuFlag: MenuHomeEnum.LegalDocuments, label: MenuLabel.LegalDocuments,
                id: MenuPermissionConfig.PARTNER_SETTINGS_BUSINESS_INFO_LEGAL_DOCUMENTS, activeMenu: 'info'
            },
            {
                root: RootEnum.PartnerSettings, menuFlag: MenuHomeEnum.PayoutAccount, label: MenuLabel.PayoutAccount,
                id: MenuPermissionConfig.PARTNER_SETTINGS_BUSINESS_INFO_PAYOUT_ACCOUNT, activeMenu: 'info'
            },
            {
                root: RootEnum.PartnerSettings, menuFlag: MenuHomeEnum.AuthorizedRepresentative, label: MenuLabel.AuthorizedRepresentative,
                id: MenuPermissionConfig.PARTNER_SETTINGS_BUSINESS_INFO_AUTHORIZED_REPRESENTATIVE, activeMenu: 'info'
            },
            {
                root: RootEnum.PartnerSettings, menuFlag: MenuHomeEnum.PartnershipTerms, label: MenuLabel.PartnershipTerms,
                id: MenuPermissionConfig.PARTNER_SETTINGS_BUSINESS_INFO_PARTNERSHIP_TERMS, activeMenu: 'info'
            }
        ];
        this.addMenuItems(partnerBusinessInfo, partnerBusinessInfoItems);
    }

    addOperatorDashboard() {
        const dashboard = {
            root: RootEnum.OperatorDashboard, menuFlag: OperatorHomeMenuEnum.Dashboard,
            label: MenuLabel.OperatorDashboard, routerLink: MenuLinkEnum.OperatorDashboard, icon: MenuIcons.Audit,
            id: MenuPermissionConfig.OPERATOR_DASHBOARD, isRoot: true,
            route: ['/operator/dashboard/home']
        };
        this.addMenuItems(this.model, [dashboard]);
    }

    addOperatorBackOffice() {
        const application = {
            root: RootEnum.BackOffice, label: MenuLabel.Application,
            icon: MenuIcons.Application, items: new Array<any>(), id: MenuPermissionConfig.BACK_OFFICE, isRoot: true
        };
        this.addMenuItems(this.model, [application]);

        //operator drivers
        const operatorsDrivers = { root: RootEnum.BackOffice, menuFlag: MenuHomeEnum.ActiveDrivers,
            label: MenuLabel.Drivers,id: MenuPermissionConfig.BACK_OFFICE_OPERATOR_DRIVERS,
            route: ['/operator/dashboard/drivers']
        };
        this.addMenuItems(application, [operatorsDrivers]);
    }

    addOperatorReports() {
        const operatorReports = {
            root: RootEnum.OperatorReports, menuFlag: OperatorHomeMenuEnum.Dashboard,
            label: MenuLabel.OperatorReports, routerLink: MenuLinkEnum.OperatorReports, icon: MenuIcons.Reports,
            id: MenuPermissionConfig.OPERATOR_REPORTS, isRoot: true,
            route: ['/operator/dashboard/reports']
        };
        this.addMenuItems(this.model, [operatorReports]);
    }

    addOperatorFinance() {
        const operatorFinance = {
            root: RootEnum.OperatorFinance, menuFlag: OperatorHomeMenuEnum.Dashboard,
            label: MenuLabel.OperatorFinance, routerLink: MenuLinkEnum.OperatorFinance, icon: MenuIcons.Finance,
            id: MenuPermissionConfig.OPERATOR_FINANCE, isRoot: true,
            route: ['/operator/dashboard/finance']
        };
        this.addMenuItems(this.model, [operatorFinance]);
    }

	ngOnInit() {
        this.permissionsSubscription = this.app.permissions$.subscribe(async (value) => {
            if (!value || !Object.keys(value).length) {
                return;
            }
            this.apiBuildNumber = this.appData.authData.BuildNumber;
            this.webBuildNumber = window['buildNumber'];
            this.permissions = value;
            this.activeRootMenu = this.appData.activeRootMenu;
            if (this.appData.authData.ClientLocationTypes && this.appData.authData.ClientLocationTypes.length > 0) {
                this.xpressClientLocationTypeList = XpressClientLocationTypeModel.XpressClientLocationTypeList.filter(item =>
                this.appData.authData.ClientLocationTypes.includes(item.id));
            }
            this.getGeoZones();
            if (this.appData.authData.roleId === XpressUserRoleEnum.TourOperator+'') {
                if (this.appData.authData.Permissions['experience-dashboard']) {
                    this.router.navigate(['/experience/dashboard']);
                } else {
                    this.router.navigate(['/experience/listing-review']);
                }
            }
            else if (this.appData.authData.roleId === XpressUserRoleEnum.Merchant+'') {
                // Partner portal
                this.merchanUserSubscription = this.appData.merchanUserSource$.subscribe((merchanUser: any) => {
                    if (!merchanUser) {
                        return;
                    }

                    if (merchanUser.MerchantStatus === MerchantStatusEnum.Activated) {
						this.initPartnerPortalMenu();
                    }
                    else {
                        const partnerHome = {
                            root: RootEnum.PartnerDashboardSwitch, menuFlag: MenuHomeEnum.PartnerDashboardSwitch,
                            label: MenuLabel.Home, routerLink: MenuLinkEnum.PartnerDashboardSwitch, icon: MenuIcons.Home,
                            id: MenuPermissionConfig.PARTNER_DASHBOARD_SWITCH, isRoot: true
                        };
                        this.addMenuItems(this.model, [partnerHome]);
                    }
                });
            }
            else if (this.appData.authData.roleId === XpressUserRoleEnum.Operator+'') {
                this.addOperatorDashboard();
                this.addOperatorBackOffice();
                this.addOperatorReports();
            }
            else {
                //Admin
				await this.loadConnexFeatureVisibility();
                this.addHome();
                this.addOpsTower();
                this.addApplication();
                this.addRegistration();
                this.addLGU();
                this.addComms();
                this.addReports();
                this.addMarketing();
                this.addFinance();
                this.addSettings();
                this.addAudit();
                this.addOperatorDashboard();
                this.addOperatorReports();
                this.addOperatorFinance();
                this.callAdminMenu();
            }
        });
    }

	private async loadConnexFeatureVisibility(): Promise<void> {
		try {
			const data = await this.operatorService.getWebConfig();
			if (data != null && data.Success !== false) {
				this.showConnexService = data.ShowConnexService !== false;
			}
		} catch {
			// Keep the menu visible when config cannot be loaded, matching the flag's true fallback.
		}
	}

    ngOnDestroy() {
        if (this.merchanUserSubscription) {
            this.merchanUserSubscription.unsubscribe();
        }
        if (this.permissionsSubscription) {
            this.permissionsSubscription.unsubscribe();
        }
    }

    private callAdminMenu() {
        this.model = [];
        if (this.selectClientLocationType === XpressClientLocationTypeEnum.Xpress ||
            this.selectClientLocationType === XpressClientLocationTypeEnum.ElNido) {
            this.initXpressportalMenuForAdmin();
        }
        else if (this.selectClientLocationType === XpressClientLocationTypeEnum.Boracay) {
            this.initBoracayPortalMenuForAdmin();
        }
        else if (this.selectClientLocationType === XpressClientLocationTypeEnum.Dumaguete) {
            this.initDumaguetePortalMenuForAdmin();
        }
    }

    private initPartnerPortalMenu(): void {
        this.addPartnerHome();
        this.addPartnerLocations();
        this.addPartnerOrders();
        this.addPartnerMenu();
        this.addPartnerInsights();
        this.addPartnerFinanceReports();
        this.addPartnerSettings();
        this.addPartnerHelp();
    }

    private initXpressportalMenuForAdmin() {
        this.addHome();
        this.addOpsTower();
        this.addApplication();
        this.addRegistration();
        this.addLGU();
        this.addComms();
        this.addReports();
        this.addMarketing();
        this.addFinance();
        this.addSettings();
        this.addAudit();
        this.addOperatorDashboard();
        this.addOperatorReports();
        this.addOperatorFinance();
    }

    private initBoracayPortalMenuForAdmin() {
        this.addHomeBoracay();
        this.addOpsTowerBoracay();
        this.addApplicationBoracay();
        this.addFeedbackBoracay();
        this.addFinance();
        this.addMarketing();

        if(!this.isLGUAdmin){
            this.addComms();
            this.addSettings();
        }
    }

    private initDumaguetePortalMenuForAdmin() {
        this.addHomeBoracay();
        this.addOpsTowerBoracay();
        this.addApplicationBoracay();
        this.addFeedbackBoracay();
        this.addMarketingDumaguete();
        this.addFinance();
        this.addSettings();
    }

    public changedGeoZone(item: any) {
        if (!item.PolygonGeometries) {
            this.isVisibleAreaNotActiveModal = true;
        }
        else {
            this.changedGeoZoneEmit.emit(item);
        }
    }

    onGeoZoneChanged(geoZone: any) {
        this.geoZoneService.setGeoZone(geoZone);
    }

    onClientLocationTypChanged(object: any) {
        if (!this.clientLocationTypeChangeInitialized) {
            this.clientLocationTypeChangeInitialized = true;
            return;
        }

        this.callAdminMenu();
        this.changeGeoZoneClientLocation();
        this.appData.setClientLocationType(object);
    }

    public getGeoZones() {
        this.geoZoneService.getGeoZones(null, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.geoZones = data.GeoZones;
                this.changeGeoZoneClientLocation();
            });

    }

    private changeGeoZoneClientLocation() {
        let geoZoneName = 'Manila';

        if (this.selectClientLocationType === XpressClientLocationTypeEnum.Xpress) {
            geoZoneName = 'Manila';
        }
        else if (this.selectClientLocationType === XpressClientLocationTypeEnum.Boracay) {
            geoZoneName = 'Boracay';
        }
        else if (this.selectClientLocationType === XpressClientLocationTypeEnum.Dumaguete) {
            geoZoneName = 'Dumaguete';
        }

        const selectedZoneItem = this.geoZones.find(item => item.Name === geoZoneName);

        if (selectedZoneItem) {
            this.changedGeoZone(selectedZoneItem);
            this.onGeoZoneChanged(selectedZoneItem);
        }
    }
}

